import React from 'react';
import { SvgIcon } from '@mui/material';

export function CloseIcon(props) {
  return (
    <SvgIcon
      sx={{ width: '14px', height: '14px', viewBox: '0 0 16px 16px' }}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1314 13.1319L3.59541 3.596"
          stroke={props.color || '#0F0F0F'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M13.1328 3.5957L3.59687 13.1316"
          stroke={props.color || '#0F0F0F'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
}
